export default defineNuxtRouteMiddleware( async (to, from) => {
    const {concurrents} = await useConcurrents();

    if (concurrents.value.length == 0) {
        abortNavigation()
    }

    if (to.query.concurrent_id == undefined) {
        return navigateTo( `${to.fullPath}/?concurrent_id=${concurrents.value[0].id}` )
    }
})